import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExposure1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExposure1"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M12 6.5V9.5M12 12.5V9.5M12 9.5H9M12 9.5H15" stroke="currentColor" strokeLinecap="square"/><Path d="M9 16.5H15" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExposure1;
